// Enum types for the application

export const EventSpaceListVariantChoices = {
  Space: 'space',
  UserSpace: 'user_space',
} as const

export enum EventSpaceStatusChoices {
  NEW = 'new',
  CONTACTED = 'contacted',
  DETAILS_PENDING = 'details_pending',
  DETAILS_RECEIVED = 'details_received',
  BOOKED = 'booked',
  PASS = 'pass',
}

export const EventSpaceStatusLabels: Record<EventSpaceStatusChoices, string> = {
  [EventSpaceStatusChoices.NEW]: 'New',
  [EventSpaceStatusChoices.CONTACTED]: 'Contacted',
  [EventSpaceStatusChoices.DETAILS_PENDING]: 'Details Pending',
  [EventSpaceStatusChoices.DETAILS_RECEIVED]: 'Details Received',
  [EventSpaceStatusChoices.BOOKED]: 'Booked',
  [EventSpaceStatusChoices.PASS]: 'Pass',
}

export enum MissingInfoRequestStatusChoices {
  NEW = 'new',
  ASSIGNED = 'assigned',
  IN_PROGRESS = 'in_progress',
  WAITING_ON_VENUE = 'waiting_on_venue',
  BLOCKED = 'blocked',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  DUPLICATE = 'duplicate',
}

export const MissingInfoRequestStatusLabels: Record<MissingInfoRequestStatusChoices, string> = {
  [MissingInfoRequestStatusChoices.NEW]: 'New',
  [MissingInfoRequestStatusChoices.ASSIGNED]: 'Assigned',
  [MissingInfoRequestStatusChoices.IN_PROGRESS]: 'In Progress',
  [MissingInfoRequestStatusChoices.WAITING_ON_VENUE]: 'Waiting on Venue',
  [MissingInfoRequestStatusChoices.BLOCKED]: 'Blocked',
  [MissingInfoRequestStatusChoices.COMPLETED]: 'Completed',
  [MissingInfoRequestStatusChoices.CANCELLED]: 'Cancelled',
  [MissingInfoRequestStatusChoices.DUPLICATE]: 'Duplicate',
}

export enum MissingInfoRequestSLATierChoices {
  TWELVE_HOURS = '12h',
  TWENTY_FOUR_HOURS = '24h',
  FORTY_EIGHT_HOURS = '48h',
  SEVENTY_TWO_HOURS = '72h',
  FIVE_DAYS = '5d',
}

export const MissingInfoRequestSLATierLabels: Record<MissingInfoRequestSLATierChoices, string> = {
  [MissingInfoRequestSLATierChoices.TWELVE_HOURS]: '12 hr',
  [MissingInfoRequestSLATierChoices.TWENTY_FOUR_HOURS]: '24 hr',
  [MissingInfoRequestSLATierChoices.FORTY_EIGHT_HOURS]: '48 hr',
  [MissingInfoRequestSLATierChoices.SEVENTY_TWO_HOURS]: '72 hours',
  [MissingInfoRequestSLATierChoices.FIVE_DAYS]: '5 days',
}

export enum MissingInfoRequestCreateSourceUIChoices {
  EXTERNAL_FLAG = 'external_flag',
  INTERNAL_FLAG = 'internal_flag',
  FAILED_SEARCH_GHOST_VENUE = 'failed_search_ghost_venue',
  FAILED_ENTITY_TAG_GHOST_VENUE = 'failed_entity_tag_ghost_venue',
}

export const MissingInfoRequestCreateSourceUILabels: Record<MissingInfoRequestCreateSourceUIChoices, string> = {
  [MissingInfoRequestCreateSourceUIChoices.EXTERNAL_FLAG]: 'External Flag',
  [MissingInfoRequestCreateSourceUIChoices.INTERNAL_FLAG]: 'Internal Flag',
  [MissingInfoRequestCreateSourceUIChoices.FAILED_SEARCH_GHOST_VENUE]: 'Failed Search Ghost Venue',
  [MissingInfoRequestCreateSourceUIChoices.FAILED_ENTITY_TAG_GHOST_VENUE]: 'Failed Entity Tag Ghost Venue',
}

export enum EventTypeChoices {
  PARTY = 'party',
  SPEAKER_SEMINAR = 'speaker_seminar',
  DINNER = 'dinner',
  BOARD_MEETING = 'board_meeting',
  COCKTAIL = 'networking_cocktail',
  OTHER = 'other',
  SHAREABLE_LIST = 'shareable_list',
}

export const EventTypeLabels: Record<EventTypeChoices, string> = {
  [EventTypeChoices.PARTY]: 'Party',
  [EventTypeChoices.SPEAKER_SEMINAR]: 'Speaker / Seminar',
  [EventTypeChoices.DINNER]: 'Dinner',
  [EventTypeChoices.BOARD_MEETING]: 'Board Meeting',
  [EventTypeChoices.COCKTAIL]: 'Networking / Cocktail',
  [EventTypeChoices.OTHER]: 'Other',
  [EventTypeChoices.SHAREABLE_LIST]: 'Shareable List',
}

export enum SupportMode {
  SELF_SERVICE = 'self_service',
  CONCIERGE = 'concierge',
}

export const SupportModeLabels: Record<SupportMode, string> = {
  [SupportMode.SELF_SERVICE]: 'Self Service',
  [SupportMode.CONCIERGE]: 'Concierge',
}

export enum EventFormat {
  SEATED = 'seated',
  STANDING = 'standing',
  MIX = 'mix',
}

export const EventFormatLabels: Record<EventFormat, string> = {
  [EventFormat.SEATED]: 'Seated',
  [EventFormat.STANDING]: 'Standing',
  [EventFormat.MIX]: 'Mix',
}

export enum BudgetType {
  TOTAL = 'total',
  PER_PERSON = 'per_person',
}

export const BudgetTypeLabels: Record<BudgetType, string> = {
  [BudgetType.TOTAL]: 'Total',
  [BudgetType.PER_PERSON]: 'Per person',
}

export enum PresentationTemplateTypes {
  DEFAULT = 'default',
  VENUE_PRESENTATION_1 = 'venue_presentation_1',
  VENUE_PRESENTATION_2 = 'venue_presentation_2',
  WP_PRESENTATION = 'wp_presentation',
}

export enum FileCategoryChoices {
  VENUE_IMAGE = 'venue_image',
  VENUE_LOGO = 'venue_logo',
  VENUE_ATTACHMENT = 'venue_attachment',
  SPACE_IMAGE = 'space_image',
  SPACE_ATTACHMENT = 'space_attachment',
  AIRTABLE_VENUES = 'airtable_venues',
  AIRTABLE_SPACES = 'airtable_spaces',
  AIRTABLE_CONTACTS = 'airtable_contacts',
  YELP_VENUES = 'yelp_venues',
  YELP_CATEGORIES = 'yelp_categories',
  VENUE_NEIGHBORHOODS = 'venue_neighborhoods',
  UNTAGGED = 'untagged',
  CUSTOMER_EVENT_ATTACHMENT = 'customer_event_attachment',
  CUSTOMER_EVENT_IMAGE = 'customer_event_image',
  EVENT_EMAIL_ATTACHMENT = 'event_email_attachment',
}

export const FileCategoryLabels: Record<FileCategoryChoices, string> = {
  [FileCategoryChoices.VENUE_IMAGE]: 'Venue Photo',
  [FileCategoryChoices.VENUE_LOGO]: 'Venue Logo',
  [FileCategoryChoices.VENUE_ATTACHMENT]: 'Venue Attachment',
  [FileCategoryChoices.SPACE_IMAGE]: 'Space Photo',
  [FileCategoryChoices.SPACE_ATTACHMENT]: 'Space Attachment',
  [FileCategoryChoices.AIRTABLE_VENUES]: 'Airtable Venues',
  [FileCategoryChoices.AIRTABLE_SPACES]: 'Airtable Spaces',
  [FileCategoryChoices.AIRTABLE_CONTACTS]: 'Airtable Contacts',
  [FileCategoryChoices.YELP_VENUES]: 'Yelp Venues',
  [FileCategoryChoices.YELP_CATEGORIES]: 'Yelp Categories',
  [FileCategoryChoices.VENUE_NEIGHBORHOODS]: 'Venue Neighborhoods',
  [FileCategoryChoices.UNTAGGED]: 'Untagged',
  [FileCategoryChoices.CUSTOMER_EVENT_ATTACHMENT]: 'Customer Event Attachment',
  [FileCategoryChoices.CUSTOMER_EVENT_IMAGE]: 'Customer Event Image',
  [FileCategoryChoices.EVENT_EMAIL_ATTACHMENT]: 'Event Email Attachment',
}
